import script from "./EmailView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__